import React from 'react';
import { Link } from "react-router-dom";
import moment from "moment";
import { DATE_FORMAT } from '../../constants';

export const EDIT = 'Edit'
export const DEFAULT_PAGE_SIZE = 10;
export const FINANCIAL = 'FINANCIAL';
export const INTERNATIONAL = 'INTERNATIONAL' 
export const DATA = 'DATA'
export const VIDEO_KYC = 'VIDEO_KYC'
export const CREATE = 'CREATE';
export const OBJECT_LIST = 'OBJECT_LIST';
export const SYSTEMDEFINED = 'SYSTEMDEFINED';
export const EDITED = 'Edited';
export const CREATED = 'Created';
export const PREDEFINED = 'PREDEFINED'
export const NONE = 'NONE';
export const SIMPLE = 'SIMPLE';
export const VERTICAL_LIST = 'VERTICAL_LIST';
export const LIST_OF_VERTICAL_KEY_VALUE = "LIST_OF_VERTICAL_KEY_VALUE";

export const SECTION_TEMPLATE_LIST_TABLE_COLUMNS = [
    {
        Header: 'Section Name',
        id: 'sectionName',
        accessor: p => <Link id={p.id} to={`/sectiontemplate/view/${p.id}`}>{p.displayName}</Link>,
        maxWidth: 300
    },
    {
        Header: 'Section Type',
        accessor: 'sectionType',
    },
    {
        Header: 'Created On',
        id: 'createdAt',
        accessor: p => <div title={p.createdAt}>{moment(p.createdAt).format(DATE_FORMAT)}</div>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title).getTime();
            b = new Date(b.props.title).getTime();
            if (b > a) return 1;
            else if (b < a) return -1;
            else if (b === a) return 0;
        }
    },
    {
        Header: 'Updated On',
        id: 'updatedAt',
        accessor: p => <div title={p.updatedAt}>{moment(p.updatedAt).format(DATE_FORMAT)}</div>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title).getTime();
            b = new Date(b.props.title).getTime();
            if (b > a) return 1;
            else if (b < a) return -1;
            else if (b === a) return 0;
        }
    }]